export function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}